<script lang="ts">
  import { tick } from "svelte";
  import { reloadForRequestedChunk } from "#lib/stale-build.ts";
  import type { ComponentProps } from "svelte";
  import type Menu from "./Menu.svelte";
  import type { MenuTrigger } from "./Menu.svelte";

  let props: Omit<ComponentProps<typeof Menu>, "open"> = $props();

  const id = $props.id();

  let LoadedMenu = $state.raw<typeof Menu | null>(null);
  let open = $state(false);
  let frame: HTMLElement | undefined;
  let loading: Promise<void> | undefined;

  const load = (): Promise<void> =>
    (loading ??= import("./Menu.svelte").then(
      async ({ default: loaded }) => {
        const focused = frame?.contains(document.activeElement) === true;
        LoadedMenu = loaded;
        if (!focused || open) return;
        await tick();
        frame?.querySelector<HTMLElement>("[aria-haspopup='menu']")?.focus();
      },
      () => {
        loading = undefined;
        if (open) void reloadForRequestedChunk();
      },
    ));

  const openWhenLoaded = (): void => {
    open = true;
    void load();
  };

  const placeholder: MenuTrigger & {
    readonly onpointerenter: () => void;
    readonly onfocus: () => void;
  } = {
    id,
    "aria-haspopup": "menu",
    "aria-expanded": false,
    "aria-controls": undefined,
    onclick: openWhenLoaded,
    onkeydown: (event: KeyboardEvent) => {
      if (event.key !== "ArrowDown") return;
      event.preventDefault();
      openWhenLoaded();
    },
    onpointerenter: load,
    onfocus: load,
  };
</script>

<div class="contents" bind:this={frame}>
  {#if LoadedMenu === null}
    <div class="relative">{@render props.trigger(placeholder)}</div>
  {:else}
    <LoadedMenu {...props} bind:open />
  {/if}
</div>
